import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import logo from '../assets/logo.png';

const images = {
  email,
  mobile,
  logo,
};

export default images;
